import { useStableCallback } from '@ipfabric/ui-components/hooks/useStableCallback';
import { type To, useLocation, useNavigate } from 'react-router-dom';

export type NavigatePushPathFunction = (to: To) => void;

export const useNavigatePushPath = (): NavigatePushPathFunction => {
  const { pathname, search } = useLocation();
  const navigate = useNavigate();

  return useStableCallback((to: To) =>
    navigate(to, { state: { nextPathName: `${pathname}${search}` } }),
  );
};
